<div class="modal-header d-flex justify-content-between">
    <nav class="navbar navbar-expand">
        @if (totalReactions?.totalCounts.length) {
            <ul class="navbar-nav">
                <li class="nav-item" [class.active]="!activeReaction" translate (click)="openReactionInfo(null)">
                    All
                </li>
                @for (reaction of totalReactions.totalCounts; track reaction) {
                    <li
                        class="nav-item"
                        [class.active]="activeReaction === reaction"
                        (click)="openReactionInfo(reaction)">
                        <app-reaction-icon [reaction]="reaction" [isShowReactionCount]="true"></app-reaction-icon>
                    </li>
                }
            </ul>
        }
    </nav>

    <button type="button" class="btn btn-icon btn-close btn-transparent" aria-label="Close" (click)="modalRef.hide()">
        <sb-inline-svg
            class="icon icon-close"
            aria-label="My icon"
            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
        </sb-inline-svg>
    </button>
</div>
<div class="modal-body">
    @if (!isLoadingTotalCounts && activeReactionData.length) {
        <div
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50"
            (scrolled)="loadMore()"
            [infiniteScrollContainer]="'.modal-body'"
            [fromRoot]="true">
            @for (user of activeReactionData; track user) {
                <div class="d-flex align-items-center mb-2">
                    <sb-user-avatar class="user-avatar-sm me-2" [user]="user" [size]="'small'" [isNeedTooltip]="false">
                    </sb-user-avatar>
                    {{ user.name }}
                </div>
            }
        </div>
    }
    @if (isLoadingTotalCounts || isLoadingReactionData) {
        <sb-loader></sb-loader>
    }
</div>
